import React, { useEffect, useState } from "react";
import { Button, Table, Empty } from "antd";
import dummyFundraisersHero from "../../../DummyData/dummyHeroList.json";
import editIcon from "../../../Assets/Images/edit-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-icon.svg";
import { useNavigate } from "react-router-dom";
import { userServices } from "../../../Services/API/userServices";
import { sessionServices } from "../../../Utils/SessionServices";
import tableCellRender from "../../../Components/TableCellRender/tableCellRender";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader/Loader";
import AlertModal from "../../../Components/AlertModal/AlertModal";
import { idExtractor } from "../../../Utils/Split";

export default function FundraisersHeroListing() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [fundRaiserHerosList, setFundRaiserHerosList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");

  useEffect(() => {
    getAllFundraiserHerosList();
  }, []);

  const getAllFundraiserHerosList = async (showLoader = true) => {
    try {
      setLoader(showLoader);
      const accessToken = await sessionServices?.getSessionStorageItem("token");
      const resp = await userServices.getUserBasedOnRole(accessToken, "HERO");
      setFundRaiserHerosList(resp?.data);
    } catch (error) {
      console.log("err", error);
    } finally {
      setLoader(false);
    }
  };

  const deleteUser = async (id) => {
    try {
      const resp = await userServices?.deleteUser(id);
      if (resp?.status === 200) {
        toast.success("Deleted Successfully");
        getAllFundraiserHerosList(false);
      }
    } catch (error) {
      console.log("error", error);
      toast.error(`${error?.response?.data || 'Something went wrong'}`);
    } finally {
      setShowDeleteModal("");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",
      fixed: 'left',
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      render: (value, row) => {
        return tableCellRender(row, "full-name");
      },
    },
    {
      title: "Organisation/Club",
      dataIndex: "club",
      key: "club",
      sorter: (a, b) => a.club.localeCompare(b.club),
      render: (value, row) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (value, row) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (value, row) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "GSA",
      dataIndex: "gsa",
      key: "gsa",
      sorter: (a, b) => a.gsa.localeCompare(b.gsa),
      render: (value, row) => {
        const gsaName = idExtractor(value, '|')[0] || ''
        return tableCellRender(gsaName, "single-val");
      },
    },
    {
      title: " ",
      dataIndex: "",
      key: "",
      width: 120,
      render: (value, row) => {
        return (
          <div className="actions-div">
            <div className="edit-fundraiser-container">
              <img
                onClick={() => {
                  navigate("/fundraiser-hero", {
                    state: { action: "edit", data: value },
                  });
                }}
                className="actions-icons"
                src={editIcon}
                alt="Edit Fundraiser"
              />
            </div>
            <div className="delete-fundraiser-container">
              <img
                className="actions-icons"
                onClick={() => {
                  setShowDeleteModal(value?.uid);
                }}
                src={deleteIcon}
                alt="Delete Fundraiser"
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="listing-page">
          <div className="listing-header-container">
            <div className="heading">Fundraiser Hero List</div>
            <div className="add-btn-container">
              <Button
                className="add-btn"
                onClick={() =>
                  navigate("/fundraiser-hero", {
                    state: { action: "add", data: "" },
                  })
                }
              >
                Add New Fundraiser Hero
              </Button>
            </div>
          </div>
          {fundRaiserHerosList?.length ? (
            <div className="table-container">
              <Table
                className="table-class"
                columns={columns}
                dataSource={fundRaiserHerosList}
                scroll={{
                  x: "auto",
                }}
              />
            </div>
          ) : (
            <div className="no-data">
              <Empty />
            </div>
          )}
        </div>
      )}
      {showDeleteModal?.length ? (
        <AlertModal
          openModal={showDeleteModal?.length}
          closeModal={() => {
            setShowDeleteModal("");
          }}
          handleYes={() => {
            deleteUser(showDeleteModal);
          }}
          title={"Fundraiser hero"}
        />
      ) : ''}
    </>
  );
}
